import { capitalizeFirstLetter } from '@lib/services/stringsService';

const normalizeRetriedChannels = (channels: { name: string; reason: string }[]) => {
  const channelsCopy = [...channels];
  // remove the current Message from the retries to show
  channelsCopy.pop();

  const onlyChannelsWithName = channelsCopy.filter((item) => Boolean(item.name));
  const normalizedChannels = onlyChannelsWithName.map((item) => ({ ...item, name: capitalizeFirstLetter(item.name) }));
  return normalizedChannels;
};

export default normalizeRetriedChannels;
